import React, { useContext } from "react";
import { Route } from "react-router-dom";
// import { Loading } from "./index";
import ControlHubContext from "../contexts/controlhub";

const PrivateRoute = ({ children, ...args }) => {
  const { cookieSession } = useContext(ControlHubContext);
  if (!cookieSession) return <></>;
  return <Route {...args}>{children}</Route>;
};

export default PrivateRoute;
